import AlertTitle from "@mui/material/AlertTitle";

export default AlertTitle;
